import React, { useEffect, useContext } from 'react';

import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { useValidation } from 'gw-portals-validation-react';
import { TranslatorContext } from '@jutro/locale';
import { Link } from '@jutro/components';
import SgSpmConvictionsDetails from 'sg-spm-convictions-details';
import SgSpmClaimDetails from 'sg-spm-claim-details';
import CommonConstants from 'sg-common-constants';

import metadata from './SgSpmClaimsAndConvictions.metadata.json5';
import messages from './SgSpmClaimsAndConvictions.messages';

function SgSpmClaimsAndConvictions(props) {
    const {
        id,
        modelVM,
        showErrors,
        updateData,
        onValidate: onValidateParent,
        isPolicyHolder,
        path,
        messageParams
    } = props;
    const translator = useContext(TranslatorContext);
    const adobeIdSuffix = isPolicyHolder ? 'PolicyHolder' : 'AdditionalDriver';

    const {
        isComponentValid,
        onValidate
    } = useValidation(id);

    const commonProps = {
        modelVM,
        showErrors,
        updateData,
        path: path,
        messageParams,
        adobeIdSuffix
    };

    useEffect(() => {
        if (onValidateParent) {
            onValidateParent(isComponentValid, id);
        }
    }, [id, isComponentValid, onValidateParent]);

    const overrides = {
        hasNonMotoringConvictions: {
            path: `${path}.hasNonMotoringConvictions`,
            label: translator(messages.UnspentNonMotoringConvictionsLabel, messageParams),
            secondaryLabel: translator(messages.UnspentNonMotoringConvictionsSubLabel, {
                pronoun: messageParams.pronoun,
                possessivePronoun: messageParams.possessivePronoun,
                link: (
                    <Link
                        id="disclosureCalculatorLink"
                        rel="noreferrer"
                        target="_blank"
                        href={CommonConstants.DISCLOSURE_CALCULATOR_LINK}
                    >
                        {CommonConstants.DISCLOSURE_CALCULATOR_LINK}
                    </Link>
                )
            }),
            adobeID: `hasNonMotoringConvictions${adobeIdSuffix}`,
        },
        SgSpmClaimDetails: {
            ...commonProps,
            onValidate
        },
        SgSpmConvictionsDetails: {
            ...commonProps,
            onValidate
        }
    };

    const resolvers = {
        resolveCallbackMap: {},
        resolveComponentMap: {
            SgSpmClaimDetails: SgSpmClaimDetails,
            SgSpmConvictionsDetails: SgSpmConvictionsDetails
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            showErrors={showErrors}
            onModelChange={updateData}
            onValidationChange={onValidate}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

export default SgSpmClaimsAndConvictions;
